import { render, staticRenderFns } from "./CodeCard.vue?vue&type=template&id=374957cb&scoped=true&"
import script from "./CodeCard.vue?vue&type=script&lang=js&"
export * from "./CodeCard.vue?vue&type=script&lang=js&"
import style0 from "./CodeCard.vue?vue&type=style&index=0&id=374957cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374957cb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VLayout})
